import axios from "axios";
import { API_BASE } from "../../config/env";
/**APPLICATION START */
export const FETCH_SAVEAPPLICATIONRESULT_FULFILLED = "FETCH_SAVEAPPLICATIONRESULT_FULFILLED";
export const FETCH_SAVEAPPLICATIONRESULT_REJECTED = "FETCH_SAVEAPPLICATIONRESULT_REJECTED";
export const FETCH_SAVEAPPLICATIONRESULT_PENDING = "FETCH_SAVEAPPLICATIONRESULT_PENDING";
export const RESET_SAVEAPPLICATIONRESULT = "RESET_SAVEAPPLICATIONRESULT"


export function saveApplicationResult(applicationId, data) {

    const token = localStorage.getItem("accessToken")

    return (dispatch) => {
        dispatch({
            type: "FETCH_SAVEAPPLICATIONRESULT",
            payload: axios({
                method: "POST",
                url: `${API_BASE}/api/v3/second-opinion/save-temporal-application-result`,
                data: { applicationId, data },
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning": "69920"
                },
            }).then((result) => result.data),
        });
    };
}

export function resetSaveApplicationResult() {
    return (dispatch) => {
        dispatch({
            type: "RESET_SAVEAPPLICATIONRESULT",
        });
    };
}


